import React from "react";
import { AdsSlotProps } from "./Ads.Slot";
import AdsSlotEngine from "./Ads.Slot.Engine";

const urlMapRegex = {
  "/$": "home",
  "^/cidades.*": "cidades",
  "^/comprova.*": "comprova",
  "^/economia/empresas-produtos.*": "empresasprodutos",
  "^/economia/loterias.*": "empresasprodutos",
  "^/economia/sobre-rodas.*": "sobrerodas",
  "^/economia.*": "economia",
  "^/eleicoes.*": "eleicoes",
  "^/goiania-90-anos.*": "goiania90anos",
  "^/esporte/atletico.*": "atletico",
  "^/esporte/goianao.*": "goianao",
  "^/esporte/goias.*": "goias",
  "^/esporte/vila-nova.*": "vilanova",
  "^/esporte.*": "esporte",
  "^/arte-e-pop.*": "arteepop",
  "^/-85-anos.*": "85anos",
  "^/o-popular-85-anos.*": "85anos",
  "^/caminhada-ecologica.*": "caminhadaecologica",
  "^/mulher-de-negócios.*": "infomercial",
  "^/infomercial.*": "infomercial",
  "^/inteligencia-artificial.*": "inteligenciaartificial",
  "^/magazine/bbb.*": "bbb",
  "^/magazine/cinema.*": "cinema",
  "^/magazine/cronicas.*": "cronicas",
  "^/magazine/famosos.*": "famosos",
  "^/magazine/gastronomia.*": "gastronomia",
  "^/magazine/horoscopo.*": "horoscopo",
  "^/magazine/opratododia.*": "opratododia",
  "^/magazine/português-expresso.*": "portuguesexpresso",
  "^/magazine/resumo-novelas.*": "resumonovelas",
  "^/magazine/saude-a-mesa.*": "saudeamesa",
  "^/magazine/saude-mental.*": "saudemental",
  "^/magazine.*": "magazine",
  "^/opiniao/artigos.*": "artigos",
  "^/opiniao/blog-fabiana-pulcineli.*": "blogfabianapulcineli",
  "^/opiniao/carta-dos-leitores.*": "cartadosleitores",
  "^/opiniao/charges.*": "charges",
  "^/opiniao/coluna-da-cileide.*": "colunadacileide",
  "^/opiniao/coluna-giro.*": "colunagiro",
  "^/opiniao/editorial.*": "editorial",
  "^/opiniao.*": "opiniao",
  "^/podcasts.*": "podcasts",
  "^/politica.*": "politica",
  "^/mundo.*": "mundo",
  "^/publicidade-legal.*": "publicidadelegal",
  "^/videos/jackson-abrao.*": "jacksonabrao",
  "^/videos/jackson-abr.*": "jacksonabrao",
  "^/videos.*": "videos",
  "^/ultimas.*": "ultimas",
} as const;

type SectionName = typeof urlMapRegex[keyof typeof urlMapRegex];

type Slot = {
  id: string;
  position: string;
  nthPosition?: Array<Number>; //Slot potion by occurence, like 0, 1, 2, 3... The number represent when to be rendered by ocorrence
  customHtml?: string;
  customEventName?: string;
};

type DeviceSlotType = {
  desktopSlot?: Slot;
  mobileSlot?: Slot;
};

type PlacementType = {
  [placement in AdsSlotProps["componentReference"]]?: DeviceSlotType;
};

type BlockType = {
  [blockType in AdsSlotProps["type"]]?: PlacementType;
};

type AdsSettings = {
  [section: string]: {
    [subsection in SectionName | "*"]?: BlockType;
  };
};

const settings: AdsSettings = {
  "Colunistas - destaques": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Manchete / Colunistas": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Infomercial - destaques": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Grid 6 > Layout Grid3": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Vídeos - CAPA ": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Cidades - Capa 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Cidades - últimas": {
    "cidades": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Cidades": {
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Comprova": {
    "comprova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Comprova Últimas": {
    "comprova": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Economia - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Capa - Super manchete com correlatas": {
    "arteepop": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goiania90anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Capa - fotão, secundárias e rodapé": {
    "eleicoes": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    // TODO: Check if this is correct
    // "block": {
    //     "top": {
    //         "mobileSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "RM1_M"
    //         }
    //     },
    //     "bottom": {
    //         "desktopSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "LEADBRD1"
    //         },
    //         "mobileSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "RM1_M"
    //         }
    //     }
    // }
  },
  "Economia - últimas (auto-9)": {
    "economia": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Economia": {
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Empresas": {
    "empresasprodutos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Sobre Rodas": {
    "sobrerodas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria": {
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    // TODO: Check if this is correct
    // "loterias": {
    //     "mega": {
    //         "top": {
    //             "desktopSlot": {
    //                 "id": "gjc_OPopular",
    //                 "position": "BILL_MAXI1"
    //             },
    //             "mobileSlot": {
    //                 "id": "gjc_OPopular",
    //                 "position": "BILL_MAXI1_M"
    //             }
    //         }
    //     }
    // },
    "atletico": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goianao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goias": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "vilanova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Esporte - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Esporte - últimas (auto-9)": {
    "esporte": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Esporte": {
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "O Popular 85 anos": {
    "85anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "O Popular 85 anos - últimas": {
    "85anos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Editoria Especial": {
    "85anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "infomercial - últimas": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Infomercial": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Magazine - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Magazine - últimas (auto-9)": {
    "magazine": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Magazine": {
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "famosos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "horoscopo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "portuguesexpresso": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "resumonovelas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "saudeamesa": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "saudemental": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Últimas BBB": {
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Crônicas - últimas": {
    "cronicas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Matéria - Crônicas": {
    "cronicas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Gastronomia": {
    "gastronomia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Matéria - Gastronomia": {
    "gastronomia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Pratododia": {
    "opratododia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Política": {
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Português Expresso": {
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Resumo das Novelas": {
    "resumonovelas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Saúde Mental": {
    "saudemental": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Mundo - CAPA ": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Mundo - últimas (auto-9)": {
    "mundo": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Mundo": {
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Opinião - CAPA": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Artigos - Últimas": {
    "artigos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Artigos": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "artigos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Fabiana": {
    "blogfabianapulcineli": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Carta dos Leitores": {
    "cartadosleitores": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Charge": {
    "charges": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Cileide": {
    "colunadacileide": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Coluna Giro": {
    "colunagiro": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas Editorial": {
    "editorial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Editorial": {
    "editorial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Jackson Abrão Entrevista": {
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Editais - Lista": {
    "publicidadelegal": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Podcasts - últimos": {
    "podcasts": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Política - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Política - últimas (auto-9)": {
    "politica": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas (auto-9)": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "ultimas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - destaques": {
    "videos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - últimas da tag": {
    "videos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Vídeos - últimas [auto-9]": {
    "videos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Matéria - vídeo": {
    "videos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": " gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": " gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas notícias": {
    "atletico": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "goianao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "goias": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "vilanova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "famosos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "horoscopo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "opratododia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "saudeamesa": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "cartadosleitores": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "charges": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "colunadacileide": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "colunagiro": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - genérica": {
    "comprova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "ultimas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Inteligência Artificial - Capa": {
    "inteligenciaartificial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Edição Digital": {
    "home": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "*": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas - Concursos e Empregos - Manual": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    },
  },
  "Saúde à Mesa - Manual": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    },
  },
  "Lateral - Últimas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "comprova": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2_M"
          }
        }
      }
    },
    "caminhadaecologica": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "cidades": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM2_M"
          }
        }
      }
    },
    "economia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM2_M"
          }
        }
      }
    },
    "esporte": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "atletico": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "goianao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "goias": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "vilanova": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "85anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "infomercial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "RM2_M"
          }
        }
      }
    },
    "inteligenciaartificial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "RM2_M"
          }
        }
      }
    },
    "magazine": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM3_M"
          }
        }
      }
    },
    "bbb": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cinema": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cronicas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "famosos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "gastronomia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "horoscopo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "opratododia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "portuguesexpresso": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "resumonovelas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "saudeamesa": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "saudemental": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "mundo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM2_M"
          }
        }
      }
    },
    "opiniao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "podcasts": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "politica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM3_M"
          }
        }
      }
    },
    "videos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    },
    "artigos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "cartadosleitores": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "charges": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "colunadacileide": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "colunagiro": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "editorial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    },
    "goiania90anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Continue lendo / Mais Lidas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    },
    "comprova": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2"
          }
        }
      }
    },
    "cidades": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "MPAG1"
          }
        }
      }
    },
    "economia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "MPAG1"
          }
        }
      }
    },
    "esporte": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "atletico": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "goianao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "goias": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "vilanova": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "85anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        }
      }
    },
    "infomercial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "MPAG1"
          }
        }
      }
    },
    "bbb": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "cinema": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "cronicas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "famosos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "gastronomia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "horoscopo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "opratododia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "portuguesexpresso": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "resumonovelas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "saudeamesa": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "saudemental": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "mundo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "MPAG1"
          }
        }
      }
    },
    "opiniao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "podcasts": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        }
      }
    },
    "politica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "MPAG1"
          }
        }
      }
    },
    "videos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "artigos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "cartadosleitores": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "charges": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "colunadacileide": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "editorial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "jacksonabrao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "colunagiro": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "caminhadaecologica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas - Concursos e Empregos": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG2"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "ultimas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "MPAG1"
          }
        }
      }
    }
  },
  "Elementos - BBB": {
    "home": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "magazine": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Elementos - Radio": {
    "arteepop": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM1_M"
          }
        }
      }
    },
    "home": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Últimas de Caminhada Ecológica": {
    "caminhadaecologica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Caminhada Ecológica": {
    "caminhadaecologica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Saúde à Mesa": {
    "magazine": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "ultimas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM2_M"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Mais lidas": {
    "arteepop": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM2_M"
          }
        }
      }
    },
    "eleicoes": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas do Opopular": {
    "arteepop": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM1_M"
          }
        }
      }
    },
    "eleicoes": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "ClassiSearch": {
    "*": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "Alright",
            "position": "HTML",
            "customHtml": "<div id='div-gpt-ad-1730134033076-0'></div>",
            "customEventName": "div-gpt-ad-1730134033076-0"
          },
          "mobileSlot": {
            "id": "Alright",
            "position": "HTML",
            "customHtml": "<div id='div-gpt-ad-1730134083458-0'></div>",
            "customEventName": "div-gpt-ad-1730134083458-0"
          }
        }
      }
    }
  },
  "generic": {
    "*": {
      "article": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "block": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "side": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "search": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "newsletter": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
    }
  },
  "Search Slot": {
    "*": {
      "search": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Search Filter": {
    "*": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Leia também": {
    "*": {
      "block": {
        "top": {
          "desktopSlot": {
            "id": "Alright",
            "position": "HTML",
            "nthPosition": [1],
            "customHtml": "<div id='div-gpt-ad-1730134121511-0'></div>",
            "customEventName": "div-gpt-ad-1730134121511-0"
          },
          "mobileSlot": {
            "id": "Alright",
            "position": "HTML",
            "nthPosition": [1],
            "customHtml": "<div id='div-gpt-ad-1730134154679-0'></div>",
            "customEventName": "div-gpt-ad-1730134154679-0"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      "article": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MBOX?"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM?_M"
          }
        }
      }
    }
  }
}

// Slot sizes to be used a fixed size for the slots
const slotSizeMap = {
  POP_HOME_SMT_BILL1_MAXI1: [300, 250],
  POP_HOME_SMT_RM1: [300, 250],
  POP_HOME_SMT_RM2: [300, 250],
  POP_HOME_SMT_RM3: [300, 250],
  POP_INTERNAS_SMT_BILL1_MAXI1: [300, 250],
  POP_INTERNAS_SMT_RM1: [300, 250],
  POP_INTERNAS_SMT_RM2: [300, 250],
  POP_INTERNAS_SMT_RM3: [300, 250],
  POP_HOME_DSK_BILL1_MAXI1: [970, 250],
  POP_INTERNAS_DSK_BILL1_MAXI1: [970, 250],
  POP_HOME_DSK_RM1: [300, 250],
  POP_HOME_DSK_RM2: [300, 250],
  POP_HOME_DSK_RM3: [300, 250],
  POP_HOME_DSK_LEADBRD1: [728, 90],
  POP_HOME_DSK_LEADBRD2: [728, 90],
  POP_HOME_DSK_LEADBRD3: [728, 90],
  POP_HOME_DSK_MPAG1: [300, 600],
  POP_HOME_DSK_MPAG2: [300, 600],
  POP_HOME_DSK_MPAG3: [300, 600],
  POP_INTERNAS_DSK_MPAG1: [300, 600],
  POP_INTERNAS_DSK_MPAG2: [300, 600],
  POP_INTERNAS_DSK_MPAG3: [300, 600],
  POP_INTERNAS_DSK_MBOX1: [600, 300],
  POP_INTERNAS_DSK_MBOX2: [600, 300],
  POP_INTERNAS_DSK_MBOX3: [600, 300],

  'gjc_OPopular.Home': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Cidades': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Ultimas': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Eleicoes': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Politica': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Esporte': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Economia': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Magazine': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Videos': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Opiniao': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Mundo': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Comprova': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Arte_e_Pop': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Inteligencia_Artificial': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  'gjc_OPopular/Especial_Publicitario': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
};

const AdsSlot: React.FC<AdsSlotProps> = ({
  type,
  componentReference = "bottom",
  data,
}) => {
  return (
    <AdsSlotEngine
      settings={settings}
      urlMapRegex={urlMapRegex}
      slotSizeMap={slotSizeMap}
      type={type}
      componentReference={componentReference}
      data={data}
    />
  )
}

export default AdsSlot;
